import React from "react";

// Default hero background for page headers
const PAGE_HEADER_BG = "/hero.webp";

const PageHeader = ({ subtitle, title, description }) => {
  return (
    <section 
      className="relative pt-40 pb-24 bg-cover bg-center"
      style={{ backgroundImage: `url(${PAGE_HEADER_BG})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-slate-900/70" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center">
          {subtitle && (
            <span className="text-sm font-semibold text-[#2ED573] uppercase tracking-wider">
              {subtitle}
            </span>
          )}
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-3">
            {title}
          </h1>
          {description && (
            <p className="text-lg text-slate-200 mt-4 max-w-2xl mx-auto">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
